import { TechnicalSpecificationsSectionsState } from 'src/app/+grid-application-shared/entities/sections-state/technicalSpecificationsSectionsState';

export class RegepTechnicalSpecificationsSectionsState extends TechnicalSpecificationsSectionsState {
  constructor(state?: any) {
    super(state);

    this.is_provisioning_of_current_transformers_locked = state ? JSON.parse(state.is_provisioning_of_current_transformers_locked) : null;
    this.provisioning_of_current_transformers_comment = state?.provisioning_of_current_transformers_comment;
    this.is_commissioning_of_energy_producer_locked = state ? JSON.parse(state.is_commissioning_of_energy_producer_locked) : null;
    this.commissioning_of_energy_producer_comment = state?.commissioning_of_energy_producer_comment;
  }

  is_provisioning_of_current_transformers_locked: boolean | null;
  provisioning_of_current_transformers_comment: string | null;
  is_commissioning_of_energy_producer_locked: boolean | null;
  commissioning_of_energy_producer_comment: string | null;
}

/* The NULL value indicates the comment is untouched or intentionally left with no value - it must be neither lock nor unlock
    https://github.com/bittner-krull/gop-web/issues/412 */
